function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11.752 2a2.752 2.752 0 012.752 2.751V19.25a2.752 2.752 0 01-5.504 0V4.751A2.752 2.752 0 0111.752 2zm7 5a2.752 2.752 0 012.752 2.751v9.499a2.752 2.752 0 01-5.504 0V9.751A2.752 2.752 0 0118.752 7zm-14 5a2.752 2.752 0 012.752 2.751v4.499a2.752 2.752 0 01-5.504 0v-4.499A2.752 2.752 0 014.752 12zm7-8.5c-.692 0-1.252.56-1.252 1.251V19.25a1.252 1.252 0 002.504 0V4.751c0-.691-.56-1.251-1.252-1.251zm7 5c-.692 0-1.252.56-1.252 1.251v9.499a1.252 1.252 0 002.504 0V9.751c0-.691-.56-1.251-1.252-1.251zm-14 5c-.692 0-1.252.56-1.252 1.251v4.499a1.252 1.252 0 002.504 0v-4.499c0-.691-.56-1.251-1.252-1.251z",
  fillRule: "nonzero"
});

var SvgPoll = function SvgPoll(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 24 24",
    fill: "#949DAA"
  }, props), _ref);
};

export default SvgPoll;